/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArchiveCabinetIcon16Light } from './ArchiveCabinetIcon16Light';
import { ArchiveCabinetIcon16Regular } from './ArchiveCabinetIcon16Regular';
import { ArchiveCabinetIcon16Solid } from './ArchiveCabinetIcon16Solid';
import { ArchiveCabinetIcon20Light } from './ArchiveCabinetIcon20Light';
import { ArchiveCabinetIcon20Regular } from './ArchiveCabinetIcon20Regular';
import { ArchiveCabinetIcon20Solid } from './ArchiveCabinetIcon20Solid';
import { ArchiveCabinetIcon24Regular } from './ArchiveCabinetIcon24Regular';
import { ArchiveCabinetIcon24Solid } from './ArchiveCabinetIcon24Solid';
import { ArchiveCabinetIcon32Regular } from './ArchiveCabinetIcon32Regular';
import { ArchiveCabinetIcon64Regular } from './ArchiveCabinetIcon64Regular';
var sizes = {
    16: {
        light: ArchiveCabinetIcon16Light,
        regular: ArchiveCabinetIcon16Regular,
        solid: ArchiveCabinetIcon16Solid,
    },
    20: {
        light: ArchiveCabinetIcon20Light,
        regular: ArchiveCabinetIcon20Regular,
        solid: ArchiveCabinetIcon20Solid,
    },
    24: {
        regular: ArchiveCabinetIcon24Regular,
        solid: ArchiveCabinetIcon24Solid,
    },
    32: {
        regular: ArchiveCabinetIcon32Regular,
    },
    64: {
        regular: ArchiveCabinetIcon64Regular,
    },
};
export var ArchiveCabinetIcon = forwardRef('ArchiveCabinetIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
